import React, { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button } from '@fluentui/react-components';
import { CheckmarkRegular, WarningRegular, CheckmarkCircleRegular } from '@fluentui/react-icons';
import { IMilestoneRule } from '../Interfaces';
import { warningClass, iconClass, completeClass } from './Gate.Styles';
import ProcessContext from '../ProcessContext';
import { ICompanyCodeParams } from '../../../common/ParamTypes';

interface IDocumentGateProps {
  rule: IMilestoneRule;
  milestoneId: number;
  disabled: boolean;
  toggleDividendsPanel: () => void;
}

const DividendGate = ({
  rule,
  milestoneId,
  disabled,
  toggleDividendsPanel,
}: IDocumentGateProps): JSX.Element => {
  const processDetail = useContext(ProcessContext);
  const { companyCode } = useParams<ICompanyCodeParams>();
  const buttonText = rule.isComplete
    ? 'View dividend information'
    : 'Update the dividend information';
  const linkButtonStyles = { padding: '0 4px', height: 40, display: 'flex', alignItems: 'center' };
  return (
    <>
      {/* TODO: update Link for Fluent UI v9 and fix Button styling with link */}
      {processDetail?.dividends?.dividendReviewId && (
        <Link
          to={`/companies/${companyCode}/dividends-review/${processDetail?.dividends.dividendReviewId}`}
          style={linkButtonStyles}
        >
          {rule.isComplete ? (
            <CheckmarkRegular className={`${iconClass} ${completeClass}`} />
          ) : (
            <WarningRegular className={`${iconClass} ${warningClass}`} />
          )}
          {buttonText}
        </Link>
      )}
      {!processDetail?.dividends?.dividendReviewId && (
        <Button
          style={{ textAlign: 'start' }}
          appearance="transparent"
          onClick={toggleDividendsPanel}
        >
          {rule.isComplete ? (
            <CheckmarkCircleRegular className={iconClass} />
          ) : (
            <WarningRegular className={`${iconClass} ${warningClass}`} />
          )}
          {buttonText}
        </Button>
      )}
    </>
  );
};

export default DividendGate;
